
import "./index.scss";
import {useEffect, useState} from "react";
import {useGet} from "../../../api/request";
import {useAlert} from "../../../components/AlertNotification";
import {useSelector} from "react-redux";

const Stats = () => {
 const getU = useGet();
 const alertU = useAlert();
 const statsUpdateTrigger = useSelector(state => state.work.statsUpdateTrigger);
  const [stats, setStats] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [timePeriod, setTimePeriod] = useState('today');

    const getAllReportsInfo = () => {
        setIsLoading(true)
let endpoint = '/users/current/statistics'

if(timePeriod === 'lastMonth') {
    endpoint = '/users/current/statistics?month=last'
} else if(timePeriod === 'today') {
    const today = new Date();
    const fromDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0)).toISOString();
    const toDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999)).toISOString();
    endpoint = `/users/current/statistics?fromDate=${fromDate}&toDate=${toDate}`
} else if(timePeriod === 'currentMonth') {
    endpoint = '/users/current/statistics'
}
        getU(endpoint)
            .then((response) =>{
                if (response.status === 'success'){
                    setStats(response.data)
                   
                }
            })
            .catch((e) =>{
                alertU({
                    status: 'error',
                    title: 'Получение заявок',
                    message: e.response.data.message
                });
            })
            .finally(() =>{
                setIsLoading(false)

            })
      
    }


useEffect(() => {
    getAllReportsInfo()
}, [timePeriod, statsUpdateTrigger])

    return <div className="main-container">
<div className="time-container">
    <button className={`time-btn ${timePeriod === 'today' && 'btn-active'}`} onClick={() => setTimePeriod('today')}>За сегодня</button>
    <button className={`time-btn ${timePeriod === 'currentMonth' && 'btn-active'}`} onClick={() => setTimePeriod('currentMonth')}>За текущий месяц</button>
    <button className={`time-btn ${timePeriod === 'lastMonth' && 'btn-active'}`} onClick={() => setTimePeriod('lastMonth')}>За предыдущий месяц</button>
</div>
<div className="stats-container">
    <div className="main-container-stat border-purple">
<h3 className="header-stat">Отработано часов</h3>
<span className="text-stat">{stats.statistics?.hours}</span>
    </div>
    <div className="main-container-stat border-purple">
<h3 className="header-stat">Количество заявок</h3>
<span className="text-stat">{stats.statistics?.applicationsCount}</span>
    </div>
    <div className="main-container-stat border-purple">
<h3 className="header-stat">Количество лидов</h3>
<div>
<span className="text-stat">{stats.statistics?.contactApplicationsCount} </span>
<span className="text-stat-percent">
  {stats.statistics?.applicationsCount > 0 ? 
    ((stats.statistics.contactApplicationsCount / stats.statistics.applicationsCount) * 100).toFixed(2) 
    : 
    "0"}%
</span>
</div>
    </div>
    <div className="main-container-stat border-gray">
<h3 className="header-stat">Количество клиентов</h3>
<span className="text-stat">{stats.statistics?.paidApplicationsCount}</span>
    </div>

    <div className="main-container-stat border-gray">
<h3 className="header-stat">KPI</h3>
<span className="text-stat">{stats.statistics?.kpi}</span>
    </div>
    <div className="main-container-stat border-gray">
<h3 className="header-stat">Совершено сделок</h3>
<span className="text-stat">{stats?.payments}</span>
    </div>
    </div>
    </div>
}


export default Stats